import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { ConfigurarPastaServiceService } from 'app/configurar-pasta-service.service';
import { AreaService } from 'app/service/cliente/area.service';

@Component({
  selector: 'app-incluir-tipo-documental',
  templateUrl: './incluir-tipo-documental.component.html',
  styleUrls: ['./incluir-tipo-documental.component.scss'],
})
export class IncluirTipoDocumentalComponent implements OnInit {
  tipos: any[];
  tiposIncluir = [];
  orderForm: FormGroup;
  clienteId: number;
  areas: any[];
  filtroArea = false;
  areaPesquisada;
  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  atributo;
  loading = true;

  areasTipo = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<IncluirTipoDocumentalComponent>,
    public areaService: AreaService,
    private _snackBar: MatSnackBar,
    public service: ConfigurarPastaServiceService,
    private formBuilder: FormBuilder
  ) {
    this.clienteId = data.dataDialog;
    //this.tiposIncluir = data.itensIncluidos;
    /*service.getTiposNaoIncluidosByCliente(data.dataDialog).subscribe(dados =>{
      console.log(dados)
      this.tipos = dados;
    })*/
  }

  ngOnInit() {
    this.orderForm = this.formBuilder.group({
      idCliente: this.clienteId,
      nodesDicionario: [],
    });
    this.listarAreas();
  }

  getTiposNaoIncluidos(idArea: number) {
    this.service.getTiposNaoIncluidosByClienteAndArea(idArea).subscribe(
      (dados) => {
        this.tipos = dados;
        setTimeout(() => {
          this.loading = false;
        }, 1000);
      },
      (err) => {
        console.error(err);
        this.loading = false;
      }
    );
  }

  incluir(item) {
    this.tiposIncluir.push(item);
    let index = this.tipos.indexOf(item);
    this.tipos.splice(index, 1);
  }

  remover(item) {
    this.tipos.push(item);
    let index = this.tiposIncluir.indexOf(item);
    this.tiposIncluir.splice(index, 1);
  }

  listarAreas() {
    this.areaService.getDescricaoAreasCliente(this.clienteId).subscribe(
      (data) => {
        this.areas = data;
        this.areas.forEach((element) => {
          this.areasTipo.push({
            value: element.id,
            viewValue: element.descricao,
          });
        });
        setTimeout(() => {
          this.loading = false;
        }, 1000);
      },
      (err) => {
        console.error(err);
        this.loading = false;
      }
    );
  }

  search(e) {
    this.loading = true;
    let value = (<HTMLSelectElement>document.getElementById('selectArea'))
      .value;
    this.areaPesquisada = e.value;
    if (e.value === 0) {
      this.openSnackBarError('Selecione uma área para realizar a listagem !');
      this.filtroArea = false;
      this.loading = false;
    }
    if (e.value > 0) {
      this.getTiposNaoIncluidos(e.value);
      this.filtroArea = true;
      this.listarTiposArea(this.clienteId, e.value);
    }
  }

  listarTiposArea(idCliente, idArea) {
    this.service.getTiposByClienteArea(idCliente, idArea).subscribe(
      (data) => {
        this.tiposIncluir = data;
        this.filtroArea = true;
        this.loading = false;
      },
      (err) => {
        console.error(err);
        this.filtroArea = true;
        this.loading = false;
      }
    );
  }

  salvarInclusoes() {
    if (this.filtroArea) {
      this.orderForm.get('nodesDicionario').setValue(this.tiposIncluir);

      this.service
        .salvarTiposDocumentaisArea(this.orderForm.value, this.areaPesquisada)
        .subscribe((dados) => {
          this.openSnackBarSuccess('Tipos Documentais editados com sucesso !');
          setTimeout(() => {
            this.dialogRef.close(this.areaPesquisada);
          }, 2000);
        });
    } else {
      this.openSnackBarError('Selecione uma area antes de salvar');
    }
  }

  // SnackBares
  openSnackBarSuccess(message: string) {
    this._snackBar.open(message, '', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 4000,
      panelClass: ['success-snackbar'],
    });
  }

  openSnackBarError(message: string) {
    this._snackBar.open(message, '', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 3000,
      panelClass: ['error-snackbar'],
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/incluir-tipo-documental/incluir-tipo-documental.component.ts